const FAQ = [
  {
    question: "How long does an exterior painting project take?",
    answer:
      "Most exterior painting projects<IN_CITY_ZIP> take 3 to 7 days depending on the size of your home, surface conditions, weather, and prep work. We’ll provide a precise timeline after your on-site consultation.",
  },
  {
    question: "What exterior surfaces can you paint?",
    answer:
      "We paint stucco, wood, siding, trim, fences, and even brick<IN_CITY_ZIP>. Each material requires proper preparation and technique. Our team ensures every surface gets the right treatment for a durable, beautiful finish.",
  },
  {
    question: "Do you help with color selection?",
    answer:
      "Yes! We provide expert color consultation<IN_CITY_ZIP> to help you choose shades that complement your home’s architecture and neighborhood. We also offer digital previews or physical samples before work begins.",
  },
  {
    question: "How do you prepare my home before painting?",
    answer:
      "We prep thoroughly with power washing, sanding, patching cracks, scraping old paint, and applying primer as needed. We also cover landscaping, windows, and hardware to protect your property<IN_CITY_ZIP> during the job.",
  },
  {
    question: "What kind of paint do you use for exteriors?",
    answer:
      "We use top-tier exterior paints<IN_CITY_ZIP> from Sherwin-Williams, Dunn-Edwards, and other trusted brands. Our products are formulated for UV resistance, moisture protection, and long-lasting color retention in Southern California’s climate.",
  },
  {
    question: "Will weather affect my painting project?",
    answer:
      "Yes, weather can delay painting. We monitor local conditions<IN_CITY_ZIP> and only proceed when the temperature and humidity are ideal. If any delays happen, we’ll communicate and reschedule efficiently.",
  },
  {
    question: "Do you offer financing for exterior painting?",
    answer:
      "Yes! We offer flexible financing<IN_CITY_ZIP> with $0 down and low monthly payments. You can pre-qualify during your free estimate without affecting your credit score.",
  },
  {
    question: "Why choose Modern Build for exterior painting?",
    answer:
      "Homeowners trust Modern Build<IN_CITY_ZIP> for our attention to detail, expert prep work, and lasting results. We combine premium materials, experienced crews, and transparent communication to give your home a fresh new look with zero stress.",
  },
];

export default FAQ;
